module.exports = __webpack_public_path__ + "static/fonts/SourceHanSansCN-Regular.20e63bb.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/SourceHanSansCN-Regular.otf
// module id = 5kGJ
// module chunks = 1